import { notification as Notification } from 'ant-design-vue';
import fcIcon from '../../icon';

const notificationInstance = {};
let defaultDuration = 4.5;
let defaultTop = '24px';
let defaultBottom = '24px';
let defaultPlacement = 'topRight';
let defaultGetContainer = () => document.body;
let defaultCloseIcon = null;

function setNotificationConfig(options) {
  const { duration, placement, bottom, top, getContainer, closeIcon } = options;
  if (duration !== undefined) {
    defaultDuration = duration;
  }
  if (placement !== undefined) {
    defaultPlacement = placement;
  }
  if (bottom !== undefined) {
    defaultBottom = typeof bottom === 'number' ? `${bottom}px` : bottom;
  }
  if (top !== undefined) {
    defaultTop = typeof top === 'number' ? `${top}px` : top;
  }
  if (getContainer !== undefined) {
    defaultGetContainer = getContainer;
  }
  if (closeIcon !== undefined) {
    defaultCloseIcon = closeIcon;
  }
}

function getPlacementStyle(placement, top = defaultTop, bottom = defaultBottom) {
  let style;
  switch (placement) {
    case 'topLeft':
      style = {
        left: 0,
        top,
        bottom: 'auto',
      };
      break;
    case 'topRight':
      style = {
        right: 0,
        top,
        bottom: 'auto',
      };
      break;
    case 'bottomLeft':
      style = {
        left: 0,
        top: 'auto',
        bottom,
      };
      break;
    default:
      style = {
        right: 0,
        top: 'auto',
        bottom,
      };
      break;
  }
  return style;
}

const typeToIcon = {
  success: 'FCcheckbox-circle-fill',
  info: 'FCinfoemation-fill',
  error: 'FCclose-circle-fill',
  warning: 'FCerro-warning-fill',
};
const typeToIconColor = {
  success: '#00B42A',
  info: '#165DFF',
  error: '#F53F3F',
  warning: '#FF7D00',
};

function notice(args) {
  const { icon, type, description, message, btn } = args;
  const outerPrefixCls = args.prefixCls || 'ant-notification';
  const prefixCls = `${outerPrefixCls}-notice`;
  const duration = args.duration === undefined ? defaultDuration : args.duration;

  let iconNode = null;
  if (icon) {
    iconNode = h => (
      <span class={`${prefixCls}-icon`}>{typeof icon === 'function' ? icon(h) : icon}</span>
    );
  } else if (type) {
    const iconType = typeToIcon[type];
    console.log('iconType', iconType);
    const iconColor = typeToIconColor[type];
    iconNode = h => <fcIcon class={`${prefixCls}-icon ${prefixCls}-icon-${type}`} className={iconType} color={iconColor} size='24px'></fcIcon>; // eslint-disable-line
  }
  let closeIconNode = null;
  if (args&&args.closeIcon) {
    closeIconNode = h => {
      const icon = typeof closeIcon === 'function' ? closeIcon(h) : closeIcon;
      const closeIconToRender = (
        <span class={`${prefixCls}-close-x`}>
          {icon || <Icon class={`${prefixCls}-close-icon`} type="close" />}
        </span>
      );
      return closeIconToRender;
    }
  } else {
    closeIconNode = h => <fc-icon className="FCclose"></fc-icon>
  }
  Notification.open({
    ...args,
    message: message,
    duration: duration || 2,
    description: description,
    icon: iconNode,
    closeIcon: closeIconNode,
  });
}

const api = {
  open: notice,
  close(key) {
    Object.keys(notificationInstance).forEach(cacheKey =>
      notificationInstance[cacheKey].removeNotice(key),
    );
  },
  config: setNotificationConfig,
  destroy() {
    Object.keys(notificationInstance).forEach(cacheKey => {
      notificationInstance[cacheKey].destroy();
      delete notificationInstance[cacheKey];
    });
  },
};

['success', 'info', 'warning', 'error'].forEach(type => {
  api[type] = args =>
    api.open({
      ...args,
      type,
    });
});

api.warn = api.warning;
export default api;
